import WrapperCard from './WrapperCard';

const styles = {
  wrapperHeaderStyle: { color: '#FFFFFF', backgroundColor: '#3B5CA9' },
  h3_1: { color: '#FFFFFF', fontSize: '14px', fontWeight: '600', marginBottom: '0' },
  h4_1: { fontSize: '20px' },
  h4_2: { fontSize: '48px', fontWeight: '600' },
  h4_3: { fontSize: '40px', fontWeight: '600' },
  regMiniCard: { borderRight: '2px solid #F0F0F0', borderBottom: 'none' },
  unregMiniCard: { borderRight: '2px solid #F0F0F0', borderBottom: 'none' },
  unMonMiniCard: { borderBottom: 'none' },
  miniCardsHeader: {
    backgroundColor: '#A8A8AA',
    padding: '5px',
  },
  miniCardContainer: {
    padding: '13px',
  },
};

function InbndOutbndCalls({ isLoading, data }) {
  const inboundCount = data?.past_30_days?.direction_count?.buckets?.inbound?.doc_count;
  const outboundCount = data?.past_30_days?.direction_count?.buckets?.outbound?.doc_count;

  return (
    <WrapperCard
      isLoading={isLoading}
      title="Call Status (30 Days)"
      headerStyle={styles.wrapperHeaderStyle}
      contentSkeletons={2}
      enableCardBody={false}
      headerTooltip="Total number of calls inbound and outbound for the last 30 days"
    >
      <div className="card">
        <div className="row ml-0 mr-0">
          <div className="col-md-6 pl-0 pr-0" style={styles.regMiniCard}>
            <div className="col" style={styles.miniCardsHeader}>
              <h3 style={styles.h3_1}>Inbound Calls</h3>
            </div>
            <div
              className="col justify-content-center align-content-center"
              style={styles.miniCardContainer}
            >
              <h4 style={styles.h4_3}>{inboundCount}</h4>
            </div>
          </div>
          <div className="col-md-6 pl-0 pr-0" style={styles.unregMiniCard}>
            <div className="col" style={styles.miniCardsHeader}>
              <h3 style={styles.h3_1}>Outbound Calls</h3>
            </div>
            <div
              className="col justify-content-center align-content-center"
              style={styles.miniCardContainer}
            >
              <h4 style={styles.h4_3}>{outboundCount}</h4>
            </div>
          </div>
        </div>
      </div>
    </WrapperCard>
  );
}

export default InbndOutbndCalls;
